module.exports = __webpack_public_path__ + "img/login-bg.92f2066f.jpg";